// extracted by mini-css-extract-plugin
export default {"h2":"styles_h2__+1GcY"};